
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjainomkareshwardarshancabs() {



    const cardData =
    {
        keyword: 'Pune to Ujjain Omkareshwar Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Ujjain Omkareshwar Darshan Cabs',
        headingDescription: ' Platinum24 Cabs offers dedicated Pune to Ujjain Omkareshwar Darshan Cabs, ensuring a smooth and spiritual journey to Madhya Pradesh’s most sacred Jyotirlinga shrines. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides safe, comfortable, and air-conditioned travel for long-distance pilgrimages. With professional chauffeurs experienced in temple routes, we guarantee timely pickups, convenient halts, and stress-free travel to both Ujjain Mahakaleshwar and Omkareshwar Jyotirlinga. Whether you’re planning a family yatra, a group pilgrimage, or a multi-day temple tour, Platinum24 Cabs delivers affordable fares, transparent packages, and a spiritually enriching experience.',

        top: 'Top Places to Visit in Ujjain Omkareshwar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga – Ujjain",
    "description": "Mahakaleshwar Temple in Ujjain is one of the 12 Jyotirlingas of Lord Shiva and among the most revered temples in India. The unique feature is the ‘Bhasma Aarti,’ where the Shiva lingam is worshipped with sacred ash every morning. The temple’s five levels house deities like Omkareshwar Mahadev and Nagchandreshwar. Pilgrims believe darshan here grants liberation and freedom from fear of death. Festivals like Maha Shivratri and Shravan attract lakhs of devotees. Mahakaleshwar is Ujjain’s eternal seat of divine energy."
  },
  {
    "title": "Omkareshwar Jyotirlinga – Mandhata Island",
    "description": "Omkareshwar, located on Mandhata Island in the Narmada River, is another sacred Jyotirlinga shrine of Lord Shiva. The island is shaped like the holy symbol ‘ॐ’ (Om), giving it unique spiritual significance. The temple attracts thousands of devotees daily, especially during Mondays and Shivratri. Pilgrims also perform parikrama around the island as an act of devotion. The sound of temple bells with the river’s flow creates a mystical aura. Omkareshwar is Madhya Pradesh’s spiritual island of divinity."
  },
  {
    "title": "Kaal Bhairav Temple – Ujjain",
    "description": "The Kaal Bhairav Temple in Ujjain is dedicated to Lord Kaal Bhairav, a fierce form of Shiva. The temple is unique as offerings of liquor are made to the deity, which is accepted miraculously. Devotees believe Kaal Bhairav protects them from evil forces. The temple is an important stop during the Ujjain pilgrimage circuit. Its mysterious rituals attract spiritual seekers and curious travelers alike. Kaal Bhairav is Ujjain’s guardian deity of strength and protection."
  },
  {
    "title": "Ram Ghat – Ujjain",
    "description": "Ram Ghat on the banks of the Shipra River is the most important bathing ghat in Ujjain. During the Kumbh Mela, millions take a holy dip here for purification. Daily evening aartis with lamps and chants create a divine atmosphere. Pilgrims also perform pind daan and other rituals at the ghat. Sunrise and sunset views from the steps are mesmerizing. Ram Ghat is Ujjain’s sacred waterfront of devotion and faith."
  },
  {
    "title": "Siddhavat – Ujjain",
    "description": "Siddhavat is a sacred banyan tree on the banks of the Shipra River in Ujjain, believed to grant siddhis (spiritual powers). Legends connect it to Goddess Parvati and Sage Narada. Devotees perform shraddha rituals here for their ancestors. The site is calm and peaceful, making it ideal for meditation. Pilgrims consider it as sacred as Gaya for ancestral rites. Siddhavat is Ujjain’s holy banyan of spiritual fulfillment."
  },
  {
    "title": "Bhartrihari Caves – Ujjain",
    "description": "The Bhartrihari Caves in Ujjain are named after the poet-saint Bhartrihari, who meditated here after renouncing worldly life. The caves are carved into sandstone cliffs near the Shipra River. Pilgrims and seekers visit for its spiritual aura. Ancient inscriptions and chambers reflect India’s ascetic traditions. Nearby temples enhance the sacred atmosphere. Bhartrihari Caves are Ujjain’s spiritual heritage of renunciation."
  },
  {
    "title": "Narmada Parikrama – Omkareshwar",
    "description": "The Narmada Parikrama around Mandhata Island is a sacred ritual in Omkareshwar. Pilgrims walk around the island, chanting prayers and seeking blessings of Mother Narmada. The path passes through scenic ghats, shrines, and natural landscapes. Legends say completing the parikrama fulfills desires and grants moksha. It takes around 4–5 hours on foot. Narmada Parikrama is Omkareshwar’s divine ritual of devotion."
  },
  {
    "title": "Kedareshwar Temple – Omkareshwar",
    "description": "Kedareshwar Temple in Omkareshwar is dedicated to Lord Shiva in the form of Kedarnath. Located close to the Jyotirlinga shrine, it is revered by pilgrims performing multiple darshans. The temple features Nagara-style architecture and ancient carvings. Rituals and aartis add to its sacred charm. Devotees believe darshan here completes the Omkareshwar pilgrimage. Kedareshwar is Omkareshwar’s companion shrine of devotion."
  },
  {
    "title": "Mamleshwar Temple – Omkareshwar",
    "description": "Mamleshwar Temple, located on the south bank of the Narmada opposite Omkareshwar, is dedicated to Lord Shiva. Also called Amreshwar, it is believed to be as sacred as Omkareshwar Jyotirlinga. The temple’s exquisite architecture features detailed stone carvings. Devotees combine darshan at both shrines as part of their pilgrimage. The temple radiates peace and spirituality. Mamleshwar is Omkareshwar’s ancient counterpart temple of divinity."
  },
  {
    "title": "Kumbh Mela – Ujjain",
    "description": "Ujjain hosts the Simhastha Kumbh Mela every 12 years, one of the largest religious gatherings in the world. Millions of pilgrims, saints, and sadhus gather to take a holy dip in the Shipra River. The city transforms into a vibrant spiritual hub with rituals, discourses, and devotional music. The energy and devotion during this period are unparalleled. For devotees, attending Simhastha is a once-in-a-lifetime experience. Kumbh Mela is Ujjain’s grand festival of faith."
  }
],



         "services": [
    {
      "name": "Pune to Ujjain Omkareshwar Taxi",
      "description": "Reliable and comfortable taxi service from Pune to Ujjain and Omkareshwar, perfect for pilgrims and travelers looking for a smooth and safe journey to these sacred destinations."
    },
    {
      "name": "Ujjain Omkareshwar Darshan Cabs Pune",
      "description": "Specialized darshan cabs from Pune to Ujjain and Omkareshwar designed to cater to pilgrims, ensuring timely pickups, comfortable rides, and knowledgeable drivers familiar with temple routes."
    },
    {
      "name": "Pune Ujjain Omkareshwar Taxi Booking",
      "description": "Easy and quick online taxi booking from Pune to Ujjain and Omkareshwar with instant confirmation, multiple vehicle options, and transparent pricing to suit your travel needs."
    },
    {
      "name": "Taxi for Ujjain Omkareshwar Darshan Pune",
      "description": "Dedicated taxi services from Pune for Omkareshwar and Ujjain darshan tours, offering flexible scheduling and packages tailored for religious trips."
    },
    {
      "name": "Pune to Ujjain Omkareshwar Car Rental",
      "description": "Convenient car rental options for travelers from Pune to Ujjain and Omkareshwar, with choices of self-drive or chauffeur-driven vehicles for a personalized travel experience."
    },
    {
      "name": "Ujjain Omkareshwar Pilgrimage Taxi Pune",
      "description": "Affordable and reliable pilgrimage taxi services from Pune to Ujjain and Omkareshwar, helping devotees visit these sacred places with ease and comfort."
    },
    {
      "name": "Affordable Cab Pune to Ujjain Omkareshwar",
      "description": "Budget-friendly cab services connecting Pune to Ujjain and Omkareshwar without compromising on safety, comfort, or reliability."
    },
    {
      "name": "Pune Ujjain Omkareshwar Private Taxi",
      "description": "Exclusive private taxi options for travelers seeking privacy and flexible itineraries on the Pune to Ujjain Omkareshwar route."
    },
    {
      "name": "Pune to Ujjain Omkareshwar Taxi Fare",
      "description": "Clear and competitive taxi fares for journeys from Pune to Ujjain and Omkareshwar, ensuring transparency and no hidden charges."
    },
    {
      "name": "Ujjain Omkareshwar Taxi Packages Pune",
      "description": "Customized taxi packages from Pune covering Ujjain and Omkareshwar, including day tours, multi-day trips, and round-trip options for a hassle-free pilgrimage."
    },
    {
      "name": "Pune Ujjain Omkareshwar One Way Taxi",
      "description": "Affordable one-way taxi services from Pune to Ujjain and Omkareshwar for travelers preferring point-to-point transport."
    },
    {
      "name": "Taxi Service Pune to Ujjain Omkareshwar",
      "description": "Comprehensive taxi services from Pune to Ujjain and Omkareshwar available 24/7 with experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Ujjain Omkareshwar Taxi with Driver Pune",
      "description": "Professional chauffeur-driven taxi services for Pune to Ujjain and Omkareshwar ensuring a safe and comfortable travel experience."
    },
    {
      "name": "Pune to Ujjain Omkareshwar Taxi Charges",
      "description": "Detailed information on taxi charges for Pune to Ujjain and Omkareshwar routes, covering fuel, tolls, and driver allowances for a transparent pricing structure."
    },
    {
      "name": "Taxi Booking Pune to Ujjain Omkareshwar",
      "description": "Seamless and convenient taxi booking services from Pune to Ujjain and Omkareshwar with flexible payment options and instant confirmation."
    }
  ],
  "tableData": [
    ["Pune to Ujjain Omkareshwar Taxi", "Ujjain Omkareshwar Darshan Cabs Pune"],
    ["Pune Ujjain Omkareshwar Taxi Booking", "Taxi for Ujjain Omkareshwar Darshan Pune"],
    ["Pune to Ujjain Omkareshwar Car Rental", "Ujjain Omkareshwar Pilgrimage Taxi Pune"],
    ["Affordable Cab Pune to Ujjain Omkareshwar", "Pune Ujjain Omkareshwar Private Taxi"],
    ["Pune to Ujjain Omkareshwar Taxi Fare", "Ujjain Omkareshwar Taxi Packages Pune"],
    ["Pune Ujjain Omkareshwar One Way Taxi", "Taxi Service Pune to Ujjain Omkareshwar"],
    ["Ujjain Omkareshwar Taxi with Driver Pune", "Pune to Ujjain Omkareshwar Taxi Charges"],
    ["Taxi Booking Pune to Ujjain Omkareshwar", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Comfortable Pune to Ujjain Omkareshwar Darshan Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs provides reliable and comfortable cab services for your spiritual journey to Ujjain and Omkareshwar."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pilgrimage Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and timely spiritual tour."
    },
    {
      "WhyChooseheading": "Spacious and Sanitized Vehicles for Group Travel",
      "WhyChoosedescription": "Travel comfortably in clean, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose customizable packages tailored to your pilgrimage schedule."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances for a worry-free journey."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with your booking needs and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Family, Group, and Spiritual Tours",
      "WhyChoosedescription": "Our Pune to Ujjain Omkareshwar cabs cater to all types of travelers seeking a peaceful pilgrimage."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers based on your travel needs."
    }
  ]



































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Ujjain Omkareshwar Darshan?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for Pune to Ujjain Omkareshwar Darshan trips.',
    },
    {
        question: 'How can I book a Pune to Ujjain Omkareshwar Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Ujjain Omkareshwar Darshan cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ujjain Omkareshwar Darshan trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your group size and travel preferences.',
    },
    {
        question: 'Are the drivers experienced with the Pune to Ujjain Omkareshwar Darshan route?',
        answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Ujjain and Omkareshwar pilgrimage routes.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Ujjain Omkareshwar Darshan?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to suit your pilgrimage plans.',
    },
    {
        question: 'What is included in the fare for Pune to Ujjain Omkareshwar Darshan cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Ujjain Omkareshwar Darshan rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune to Ujjain Omkareshwar Darshan route.',
    },
    {
        question: 'Are safety measures in place for Pune to Ujjain Omkareshwar Darshan cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Ujjain Omkareshwar Darshan travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your pilgrimage needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services for Pune to Ujjain Omkareshwar Darshan?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Ujjain Omkareshwar Darshan routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Deshmukh',
        feedback: 'The Pune to Ujjain Omkareshwar Darshan cab service by Platinum24 Cabs was comfortable and the driver was very helpful.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Booking a cab for Ujjain Omkareshwar Darshan was simple, and the entire trip was smooth and enjoyable.',
        rating: 5,
    },
];












































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToUjjainOmkareshwarSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Omkareshwar Darshan Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-ujjain-omkareshwar-cab.jpg",
  "description": "Book Pune to Ujjain Omkareshwar Darshan cabs with Platinum24 Cabs. Comfortable taxi services for pilgrimage to Ujjain and Omkareshwar temples with professional drivers and flexible packages.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-ujjain-omkareshwar-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Ujjain Omkareshwar Darshan Cabs | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable Pune to Ujjain Omkareshwar Darshan taxi service by Platinum24 Cabs. Book AC cabs for Ujjain and Omkareshwar pilgrimage with experienced drivers and affordable fares."
  />
  <meta
    name="keywords"
    content="Pune to Ujjain Omkareshwar Taxi, Ujjain Omkareshwar Darshan Cabs Pune, Pune Ujjain Omkareshwar Taxi Booking, Taxi for Ujjain Omkareshwar Darshan Pune, Pune to Ujjain Omkareshwar Car Rental, Ujjain Omkareshwar Pilgrimage Taxi Pune, Affordable Cab Pune to Ujjain Omkareshwar, Pune Ujjain Omkareshwar Private Taxi, Pune to Ujjain Omkareshwar Taxi Fare, Ujjain Omkareshwar Taxi Packages Pune, Pune Ujjain Omkareshwar One Way Taxi, Taxi Service Pune to Ujjain Omkareshwar, Ujjain Omkareshwar Taxi with Driver Pune, Pune to Ujjain Omkareshwar Taxi Charges, Taxi Booking Pune to Ujjain Omkareshwar"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToUjjainOmkareshwarSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoujjainomkareshwardarshancabs;